var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img_load"},[_c('el-image',{staticClass:"img_load",attrs:{"src":_vm.$img_path + _vm.id,"fit":_vm.fit,"alt":_vm.alt}},[_c('div',{attrs:{"slot":"error"},slot:"error"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }